import _image from '@/assets/images/oval.png'

const model = {
  name: null,
  description: null,
  startAt: null,
  endAt: null,
  account: null,
  organization: null,
  sites: [],
  photo: {
    path: _image,
  },
  leaderboard: [],
  rewards: [
    {
      name: '',
      photo: {
        path: null,
        _id: null,
      },
      position: 1,
    },
    {
      name: '',
      photo: {
        path: null,
        _id: null,
      },
      position: 2,
    },
    {
      name: '',
      photo: {
        path: null,
        _id: null,
      },
      position: 3,
    },
  ],
  createdAt: null,
  updatedAt: null,
  createdTimestamp: null,
  updatedTimestamp: null,
}

export default model
